import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3d2wzlqi: FaireBrandEntity = {
  token: "b_3d2wzlqi",
  type: "brand",
  name: "River Organics",
  avatarUrl:
    "https://cdn.faire.com/fastly/d7982b54a922c2960ae3ba4dd8bde43492efbf23fe0a5cfd730a03124cac032b.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/2c0482a1f2831410b401ec9f37a7e671dae9128584ae1fd3e3d190ac8a747d8a.png",
  logoUrl:
    "https://cdn.faire.com/fastly/d7982b54a922c2960ae3ba4dd8bde43492efbf23fe0a5cfd730a03124cac032b.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2c0482a1f2831410b401ec9f37a7e671dae9128584ae1fd3e3d190ac8a747d8a.png",
  location: "Wilmington, NC, USA",
  minimumOrderDollars: 10,
  rating: 4.8,
  reviewCount: 190,
  isInsider: true,
  description:
    "River Organics is an independent beauty company located in Wilmington, North Carolina.  Formulated to be  safe for all skin types, our line of makeup offers a simplified approach to beauty and skin care. With all of our products we strive to offer you the best vegan zero waste products without compromising quality or durability. The products are conceived by wife and husband team Corinne & Fabien, natives of Canada and France. Corinne is an art historian with an eye for simple beauty and Fabien is a natural product chemist who worked in the Chanel skin care laboratories in the south of France, where they both lived for 8 years.  Life in France, and travels in Italy and the Middle East introduced Corinne to beauty regimens in which oil, not creams, formed the basis for moisturizing the skin. The goal is for your natural beauty to shine through with a little help. \n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:12.640Z",
    importedBy: "entity-db-cli",
  },
};
